import { AppCardTitle, AppProviderBlock, AppToggleButton } from '@components'
import React from 'react'
import {
	Box, Card, CardContent, Typography, Table, TableHead, TableBody, TableRow, TableCell,
	Grid
} from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { dsColorNew } from "@palette"
import { alpha } from "@mui/material/styles"


const DATES = ['15/03', '22/03', '01/04']
// Booking weeks come as week numbers, as the backend sends them (the week the price was collected)
const WEEKS = ['40', '41', '42']
const PROVIDERS = ['DrivePro', 'FleetMax', 'CarFirst']

const OFFICES = [
	{
		name: 'Madrid Barajas Airport',
		prices: {
			'15/03': {
				DrivePro:  [{ price: '€48.30', cheapest: false, expensive: false, evo: 'increase', diff: 3.2 }, { price: '€45.10', cheapest: true, expensive: false, evo: 'decrease', diff: 2.1 }, { price: '€52.80', cheapest: false, expensive: false, evo: null, diff: null }],
				FleetMax:  [{ price: '€42.50', cheapest: true, expensive: false, evo: 'decrease', diff: 5.4 }, { price: '€44.20', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€46.90', cheapest: false, expensive: false, evo: 'increase', diff: 1.8 }],
				CarFirst:  [{ price: '€55.10', cheapest: false, expensive: true, evo: 'increase', diff: 8.1 }, { price: '€51.30', cheapest: false, expensive: false, evo: 'decrease', diff: 1.5 }, { price: '€58.40', cheapest: false, expensive: true, evo: 'increase', diff: 4.2 }],
			},
			'22/03': {
				DrivePro:  [{ price: '€52.10', cheapest: false, expensive: false, evo: 'increase', diff: 2.8 }, { price: '€49.80', cheapest: true, expensive: false, evo: 'decrease', diff: 3.5 }, { price: '€54.20', cheapest: false, expensive: false, evo: null, diff: null }],
				FleetMax:  [{ price: '€45.90', cheapest: true, expensive: false, evo: 'decrease', diff: 4.1 }, { price: '€47.30', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€50.10', cheapest: false, expensive: false, evo: 'increase', diff: 2.3 }],
				CarFirst:  [{ price: '€59.80', cheapest: false, expensive: true, evo: 'increase', diff: 6.7 }, { price: '€56.20', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€62.40', cheapest: false, expensive: true, evo: 'increase', diff: 3.9 }],
			},
			'01/04': {
				DrivePro:  [{ price: '€58.90', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€55.40', cheapest: true, expensive: false, evo: 'decrease', diff: 4.2 }, { price: '€61.70', cheapest: false, expensive: false, evo: 'increase', diff: 1.9 }],
				FleetMax:  [{ price: '€50.20', cheapest: true, expensive: false, evo: 'decrease', diff: 6.3 }, { price: '€52.80', cheapest: false, expensive: false, evo: 'increase', diff: 1.1 }, { price: '€55.40', cheapest: false, expensive: false, evo: null, diff: null }],
				CarFirst:  [{ price: '€65.30', cheapest: false, expensive: true, evo: 'increase', diff: 9.2 }, { price: '€61.10', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€68.50', cheapest: false, expensive: true, evo: 'increase', diff: 5.1 }],
			},
		},
	},
	{
		name: 'Barcelona El Prat',
		prices: {
			'15/03': {
				DrivePro:  [{ price: '€51.20', cheapest: false, expensive: false, evo: 'increase', diff: 2.1 }, { price: '€48.90', cheapest: true, expensive: false, evo: 'decrease', diff: 3.8 }, { price: '€54.60', cheapest: false, expensive: false, evo: null, diff: null }],
				FleetMax:  [{ price: '€44.80', cheapest: true, expensive: false, evo: 'decrease', diff: 4.7 }, { price: '€46.50', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€49.20', cheapest: false, expensive: false, evo: 'increase', diff: 2.5 }],
				CarFirst:  [{ price: '€57.90', cheapest: false, expensive: true, evo: 'increase', diff: 7.3 }, { price: '€54.10', cheapest: false, expensive: false, evo: 'decrease', diff: 2.0 }, { price: '€61.30', cheapest: false, expensive: true, evo: 'increase', diff: 5.6 }],
			},
			'22/03': {
				DrivePro:  [{ price: '€55.40', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€52.10', cheapest: true, expensive: false, evo: 'decrease', diff: 2.9 }, { price: '€57.80', cheapest: false, expensive: false, evo: 'increase', diff: 1.4 }],
				FleetMax:  [{ price: '€48.30', cheapest: true, expensive: false, evo: 'decrease', diff: 3.6 }, { price: '€50.70', cheapest: false, expensive: false, evo: 'increase', diff: 0.8 }, { price: '€53.10', cheapest: false, expensive: false, evo: null, diff: null }],
				CarFirst:  [{ price: '€62.50', cheapest: false, expensive: true, evo: 'increase', diff: 5.9 }, { price: '€58.90', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€65.80', cheapest: false, expensive: true, evo: 'increase', diff: 4.3 }],
			},
			'01/04': {
				DrivePro:  [{ price: '€61.80', cheapest: false, expensive: false, evo: 'increase', diff: 3.4 }, { price: '€58.20', cheapest: true, expensive: false, evo: 'decrease', diff: 5.1 }, { price: '€64.50', cheapest: false, expensive: false, evo: null, diff: null }],
				FleetMax:  [{ price: '€53.70', cheapest: true, expensive: false, evo: 'decrease', diff: 7.2 }, { price: '€55.90', cheapest: false, expensive: false, evo: null, diff: null }, { price: '€58.30', cheapest: false, expensive: false, evo: 'increase', diff: 2.0 }],
				CarFirst:  [{ price: '€68.40', cheapest: false, expensive: true, evo: 'increase', diff: 8.5 }, { price: '€64.70', cheapest: false, expensive: false, evo: 'decrease', diff: 1.3 }, { price: '€71.90', cheapest: false, expensive: true, evo: 'increase', diff: 6.1 }],
			},
		},
	},
]

// Same price box as the page's prices column: cheapest red, most expensive blue, evolution arrow under the price
function PriceBox({ data }) {
	const tone = data.cheapest ? dsColorNew.dangerRed : data.expensive ? dsColorNew.appBlue : null
	const evoColor = data.evo === 'increase' ? dsColorNew.successText : dsColorNew.dangerRed

	return <Box sx={{
		border: '1px solid', borderColor: tone ? alpha(tone, 0.45) : dsColorNew.grayBorder,
		backgroundColor: tone ? alpha(tone, 0.08) : dsColorNew.white,
		borderRadius: '8px', textAlign: 'center', py: 0.5, px: 0.5, minWidth: 75,
	}}>
		<Typography sx={{ fontWeight: 700, fontSize: 13, color: dsColorNew.textTitle }}>{data.price}</Typography>
		<Box sx={{ height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.75 }}>
			{data.evo && <>
				<IconSeeker icon={data.evo === 'increase' ? 'arrow-up' : 'arrow-down'} sx={{ fontSize: 12, color: evoColor }}/>
				<Typography sx={{ fontSize: 11, color: dsColorNew.textDark }}>{data.diff}%</Typography>
			</>}
		</Box>
	</Box>
}


export default function PricingEnvironmentDemoData() {
	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Card>
				<CardContent sx={{ p: 2 }}>
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
						<AppCardTitle icon="table-cells" title="Pricing Environment"/>
						<AppToggleButton value="min" onChange={() => {}} buttonProps={{ sx: { px: 2.5, py: 1 } }} tabs={[{ value: 'min', label: 'Min. Price' }, { value: 'avg', label: 'Avg. Price' }, { value: 'max', label: 'Max. Price' }]}/>
					</Box>

					<Box sx={{ overflowX: 'auto' }}>
						<Table size="small">
							<TableHead>
								{/* Top header: Branch / Providers + dates */}
								<TableRow sx={{ '& th': { textAlign: 'center', borderBottom: 0 } }}>
									<TableCell rowSpan={2} sx={{ minWidth: 150, position: 'sticky', left: 0, zIndex: 3, verticalAlign: 'middle', textAlign: 'left !important' }}>
										<Typography sx={{ fontWeight: 500, fontSize: 13, textTransform: 'none', color: alpha(dsColorNew.white, 0.72) }}>Branch / Providers</Typography>
									</TableCell>
									{DATES.map(date => (
										<TableCell key={date} colSpan={WEEKS.length} sx={{ textAlign: 'center' }}>
											{date}
										</TableCell>
									))}
								</TableRow>
								{/* Sub header: booking weeks, the navy band under each date as on the page; square corners, it is not the top edge */}
								<TableRow sx={{ '& th': { bgcolor: dsColorNew.navy, color: dsColorNew.white, fontSize: 13, textAlign: 'center', borderRadius: 0 } }}>
									{DATES.map(date =>
										WEEKS.map(week => (
											<TableCell key={`${date}-${week}`}>{week}</TableCell>
										))
									)}
								</TableRow>
							</TableHead>
							<TableBody>
								{OFFICES.map((office, oi) => <React.Fragment key={oi}>
									<TableRow sx={{ '& td': { bgcolor: dsColorNew.pillTrackBg, py: 1, borderBottom: `1px solid ${dsColorNew.grayBorder}` } }}>
										<TableCell sx={{ position: 'sticky', left: 0, zIndex: 2, whiteSpace: 'nowrap', pl: 2 }}>
											<Typography sx={{ fontWeight: 600, fontSize: 13, color: dsColorNew.textTitle }}>{office.name}</Typography>
										</TableCell>
										<TableCell colSpan={DATES.length * WEEKS.length}/>
									</TableRow>
									{PROVIDERS.map((provider, pi) => (
										<TableRow key={`${oi}-${pi}`} sx={{ '& td': { py: 1 } }}>
											<TableCell sx={{ bgcolor: dsColorNew.white, position: 'sticky', left: 0, zIndex: 2, pl: 2, whiteSpace: 'nowrap', boxShadow: `6px 0 8px -6px ${alpha(dsColorNew.textTitle, 0.18)}` }}>
												<Typography component="div" sx={{ fontWeight: 500, fontSize: 13, color: dsColorNew.textDark }}><AppProviderBlock provider={provider}/></Typography>
											</TableCell>
											{DATES.map(date =>
												WEEKS.map((week, wi) => {
													const data = office.prices[date]?.[provider]?.[wi]
													return <TableCell key={`${date}-${week}-${provider}`} sx={{ textAlign: 'center', p: 0.5 }}>
														{data ? <PriceBox data={data} /> : <Typography sx={{ borderRadius: '8px', textAlign: 'center', fontSize: 13, color: dsColorNew.textSubtle, border: `1px dashed ${dsColorNew.grayBorder}` }}>N/A</Typography>}
													</TableCell>
												})
											)}
										</TableRow>
									))}
								</React.Fragment>)}
							</TableBody>
						</Table>
					</Box>
				</CardContent>
			</Card>
		</Grid>
	</Grid>
}
